import { z } from "zod";
import { RouteMap } from "./customerReporting";

export const contractorPayStatementDeductionSchema = z.object({
  name: z.string(),
  type: z.string(),
  current: z.number(),
  year_to_date: z.number(),
});

export const contractorPayStatementItemSchema = z.object({
  paymentItemID: z.string(),
  service_date: z.string().nullable().optional(),
  earning_type: z.string(),
  rate: z.number().nullable().optional(),
  quantity: z.number().nullable().optional(),
  amount: z.number(),
  work_description: z.string().nullable().optional(),
});

export const contractorPayStatementDataSchema = z.object({
  kind: z.literal(RouteMap.contractor_pay_statement),
  contractorPaymentID: z.string(),
  pay_date: z.string(),
  pay_period_start: z.string().nullable().optional(),
  pay_period_end: z.string().nullable().optional(),
  disbursement_method: z.string(),
  disbursement_last4: z.string().nullable().optional(),
  contractor: z.object({
    name: z.string(),
    address: z.string().nullable().optional(),
    city_state_zip: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    ssn_last4: z.string().nullable().optional(),
  }),
  summary: z.object({
    gross_amount: z.number(),
    deductions: z.number(),
    net_amount: z.number(),
    gross_amount_ytd: z.number(),
    deductions_ytd: z.number(),
    net_amount_ytd: z.number(),
  }),
  payment_items: z.array(contractorPayStatementItemSchema),
  deductions: z.array(contractorPayStatementDeductionSchema),
});

export type IContractorPayStatementData = z.infer<
  typeof contractorPayStatementDataSchema
>;

export type IContractorPayStatementItem = z.infer<
  typeof contractorPayStatementItemSchema
>;

export type IContractorPayStatementDeduction = z.infer<
  typeof contractorPayStatementDeductionSchema
>;
